import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { Tooltip } from '@dealstack/frontend/shared/components/Tooltip/Tooltip';
import { ITextProps } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';

interface Props {
	tooltipText: string;
	mainText: string;
	numberOfLines?: number;
	elipsisEnabled?: boolean;
	textProps: ITextProps;
	className?: string;
}

export const TextWithTooltip = ({
	tooltipText,
	mainText,
	numberOfLines = 2,
	elipsisEnabled = true,
	textProps = {},
}: Props) => {
	return (
		<Tooltip hoverChildrenInsteadIcon tooltip={tooltipText}>
			<Text
				multiLineElipsis={{ enabled: elipsisEnabled, numberOfLines }}
				{...textProps}
				disableVariantMapping
			>
				{mainText}
			</Text>
		</Tooltip>
	);
};
